import { VMWareCluster } from '@amzn/awscat-portfolio-assessment-types';

/**
 * Sums up the number of hosts from all clusters
 * @param  {VMWareCluster[]} clusters
 * @returns number of hosts
 */
export const getVMWareHostCount = (clusters: VMWareCluster[]): number => {
    return clusters.reduce((sum, cluster) => {
        return sum + cluster.hostCount;
    }, 0);
};
